import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface Props {
  variant?: 'red' | 'blue' | 'dark' | 'white';
  size?: 'sm' | 'lg';
}
export function CountdownTimer({
  variant = 'red',
  size = 'lg'
}: Props) {
  const {
    minutes,
    seconds
  } = useCountdown();
  const bgColors = {
    red: 'bg-red-800 text-white',
    blue: 'bg-blue-800 text-white',
    dark: 'bg-gray-800 text-white',
    white: 'bg-white text-red-600'
  };
  const textColors = {
    red: 'text-red-800',
    blue: 'text-blue-800',
    dark: 'text-gray-800',
    white: 'text-white'
  };
  const sizeClasses = {
    sm: 'text-sm px-2 py-1 rounded',
    lg: 'text-2xl md:text-3xl px-4 py-2 rounded-lg'
  };
  return <div className={`flex items-center space-x-1 md:space-x-2 font-bold ${size === 'sm' ? 'text-sm' : 'text-xl md:text-2xl'}`} data-id="element-39">
      <div className={`${sizeClasses[size]} ${bgColors[variant]} shadow-inner`} data-id="element-40">
        {minutes.toString().padStart(2, '0')}
      </div>
      <span className={`${textColors[variant]} font-black`} data-id="element-41">:</span>
      <div className={`${sizeClasses[size]} ${bgColors[variant]} shadow-inner`} data-id="element-42">
        {seconds.toString().padStart(2, '0')}
      </div>
    </div>;
}